import React from 'react'
import { useMemo } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

import SubSessionStoke from './SubSessionStoke';


const SubCategoryStoke = ({data}) => {
    const columns = useMemo(
        () => [
          {
            accessorKey: 'categoryName', //access nested data with dot notation
            header: ' اسم التصنيف',
            size: 150,
          },
          {
            accessorKey: 'inventoryTurnover',
            header: 'معدل دوران الاصناف  ( ITR )',
            size: 150,
            
          },
          {
            accessorKey: 'dsi',
            header: 'عدد ايام بيع المخزون  ( DSI )',
            size: 150,
            enableSorting: true,
          },
          {
            accessorKey: 'sellThroughRate',
            header: 'معدل البيع ( STR )',
            size: 150,
            enableSorting: true,
          },
        ],
        [],
      );
    
      const table = useMaterialReactTable({
        columns,
        data,
        columnResizeDirection: 'rtl',
        enableExpandAll: false,
        muiDetailPanelProps: () => ({
          sx: (theme) => ({
            backgroundColor:
              theme.palette.mode === 'dark'
                ? 'rgba(255,210,244,0.1)'
                : 'rgba(0,0,0,0.1)',
          }),
        }),
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        muiSearchTextFieldProps: {
          size: 'small',
          variant: 'outlined',
        },
        muiPaginationProps: {
          color: 'secondary',
          shape: 'rounded',
          variant: 'outlined',
          rowsPerPageOptions: [10, 20, 50], // Options for rows per page
  
         
        },
        renderDetailPanel: ({ row }) => (
          <section>
            
           <div className='mt-5'>
           <SubSessionStoke data={row.original.seasonDetails} />
           </div>
         </section> 
       ),
        pagination: {
          pageSize: 20, // Default page size
        },
        muiExpandButtonProps: ({ row, table }) => ({
          onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), 
          sx: {
            transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s',
          },
        }),
        pagination: {
          pageSize: 20// Default page size
        },
      })
      return <MaterialReactTable table={table} />;
    };

export default SubCategoryStoke